module.exports = __webpack_public_path__ + "static/media/21st-Press-2016_Final.3ffcc917.jpg";